import { useRef } from 'react'
import { stylesheet, classes, style } from 'typestyle'

/* Contents ===================================================================================== */
import { GLOBAL_CONTENTS } from '../../../common/global-contents'

/* Common ======================================================================================= */
import { flat, structureObj } from '../../../share/obj-equal'
import { FIELDS } from '../../../share/fields'

/* Hooks ======================================================================================== */
import useValue from '../../../hooks/use-value'
import useFetch from '../../../hooks/use-fetch'
import useLocal from '../../../hooks/use-local'

/* Components =================================================================================== */
import { Box } from '../../../components/box/box.component'
import { Button } from '../../../components/button'
import { Form } from '../../../components/form'
import { Line } from '../../../components/line'
import { Modal } from '../../../components/modal'
import { Notification } from '../../../components/notification'
import { renderForm } from '../../../modules/handlers/render-form'

/* Styles ======================================================================================= */
import { createMediaQuery } from '../../../components/style-class/style-class.utils'
import { p12 } from '../../../styles/styleset/padding/p12'
import { pb0 } from '../../../styles/styleset/padding/pb0'
import { mr8 } from '../../../styles/styleset/margin/mr8'

Modal.add('FieldEdit', (props: any) => {
  const {
    field,
    pathName,
    value,
    onUpdate,
    fields,
    onSubmit,
    replace,
    maxWidth,
    parentRowId,
  } = props
  const [local] = useLocal()
  const [patch, $patch] = useFetch()
  const [values, $values] = useValue(
    value
      ? flat({
        [field.name]: value == '-' ? '' : value,
      })
      : {},
  )
  const [isClosingConfirmed] = useValue(false)
  const formBodyRef = useRef(null)

  return (
    <Box baseline="background" onClick={props.handleContentClick} rounded row relative>
      <Form
        values={structureObj(values)}
        onSubmit={(body: any) => {
          $values.set(flat(body))

          if (onSubmit) {
            onSubmit(body)
            Modal.pop()
          } else {
            $patch
              .patch({
                url: `${process.env.REACT_APP_API_URL}${pathName}`,
                body: {
                  replace,
                  ...body,
                },
              })
              .then((payload: any) => {
                if (payload.code === 403) {
                  Notification.push({
                    label: GLOBAL_CONTENTS.insufficientPermission[local],
                    baseline: 'error',
                    alt: true,
                  })
                } else {
                  if (onUpdate) {
                    onUpdate()
                    Notification.push({ label: GLOBAL_CONTENTS.updatedSuccessfully[local] })
                  }
                }

                Modal.pop()
              })
          }
        }}
      >
        <Box
          // baseline="background"
          className={classes(
            STYLES.containerInner,
            field.type !== FIELDS.ASYNC_SELECT &&
            field.type !== FIELDS.ASYNC_MULTI_SELECT &&
            field.type !== FIELDS.HOURS &&
            STYLES.containerOverflowAuto,
            p12,
            pb0,
            style({
              // height: '100%',
              // maxWidth: 960,
            }),
          )}
          centerAutoX
          maxWidth={maxWidth}
          ref={formBodyRef}
        >
          {(() => {
            if (
              fields &&
              field.type !== FIELDS.REPEATER &&
              field.type !== FIELDS.ASYNC_MULTI_SELECT
            ) {
              return fields.map((field: any) => {
                return renderForm({
                  field,
                  isFromView: true,
                  formRef: formBodyRef,
                  parentRowId,
                })
              })
            } else {
              return renderForm({
                field,
                isFromView: true,
                formRef: formBodyRef,
                parentRowId,
              })
            }
          })()}
        </Box>
        <Line />
        <Box
          className={classes(STYLES.containerInner, p12)}
          baseline="surface"
          spaceBetween
          fullWidth
        >
          <Box />
          <Box baseline="none" spaceBetween>
            <Box />
            <Box column>
              <Button
                className={mr8}
                onClick={() => {
                  Modal.pop()
                }}
                label={
                  isClosingConfirmed
                    ? GLOBAL_CONTENTS.closeConfirm[local]
                    : GLOBAL_CONTENTS.close[local]
                }
                baseline="background"
                size="md"
                square
              />

              <Button
                label={
                  patch.meta.isLoading ? GLOBAL_CONTENTS.saving[local] : GLOBAL_CONTENTS.save[local]
                }
                type="submit"
                baseline="primary"
                size="md"
                square
              />
            </Box>
          </Box>
        </Box>
      </Form>
    </Box>
  )
})

const STYLES = stylesheet({
  container: {
    ...createMediaQuery['md']({
      width: 'calc(100% - 16px)',
    }),
  },
  containerInner: {
    minWidth: 400,
    maxHeight: 620,
    // maxWidth: 400,
    width: '100%',
    ...createMediaQuery['md']({
      maxHeight: 360,
      minWidth: 'inherit !important',
      maxWidth: '100%',
    }),
  },
  containerOverflowAuto: {
    overflow: 'auto',
  },
})
